import on from '../lib/on';
import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.team-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const filters = queryAll('.button-filter');
    const boxes = queryAll('.team-member');
    boxes.forEach((box) => {
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: box,
                start: 'top 100%',
            },
        });
        timeline.fromTo(box, { opacity: '0' }, {
            opacity: 1, stagger: 0.1, duration: 0.3, ease: 'easeOut',
        }, 'start+=0.05');
    });

    let timelineFilters;
    // eslint-disable-next-line func-names
    on(filters, 'click', function () {
        if (this.classList.contains('active')) return;
        filters.forEach((filter) => filter.classList.remove('active'));
        this.classList.add('active');
        const { slug } = this.dataset;
        let activeBoxes;
        let hiddenBoxes;
        if (slug === 'all') {
            activeBoxes = boxes;
            hiddenBoxes = [];
        } else {
            activeBoxes = boxes.filter((box) => box.dataset.slug.includes(slug));
            hiddenBoxes = boxes.filter((box) => !box.dataset.slug.includes(slug));
        }
        if (timelineFilters) timelineFilters.pause();
        timelineFilters = gsap.timeline({ paused: true });
        timelineFilters.addLabel('start');
        timelineFilters.fromTo(boxes, {
            opacity: 1,
        }, {
            opacity: 0,
            duration: 0.2,
            ease: 'easeOut',
        }, 'start+=0');
        timelineFilters.call(() => {
            activeBoxes.forEach((box) => {
                box.style.display = 'block';
            });
            hiddenBoxes.forEach((box) => {
                box.style.display = 'none';
            });
        }, null, 'start+=0.3');
        timelineFilters.fromTo(activeBoxes, {
            opacity: 0,
        }, {
            opacity: 1,
            stagger: 0.1,
            duration: 0.2,
        }, 'start+=0.3');
        timelineFilters.play();
    });
};

export { sectionSelector, sectionCallBack };
